import sdl from '@jds/react-generated-sdl/JDSBottomFooterLinkItem';
import type { JDSBottomFooterLinkItemProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSBottomFooterLinkItemProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { separator = true, custom = '', ...rest } = props as any;
  return createComponent(
    json,
    { separator, ...rest },
    'JDSBottomFooterLinkItem',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const BottomFooterLinkItem = withLogic(
  Component
) as React.FC<JDSBottomFooterLinkItemProps> & { slotName?: string };

BottomFooterLinkItem.displayName = 'BottomFooterLinkItem';
BottomFooterLinkItem.slotName = 'jds_bottom_footer_link_item';

export { BottomFooterLinkItem, type JDSBottomFooterLinkItemProps };
